import { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { AuthContext } from "../components/AuthContext";

export default function RequireInvestmentAccess({ children }) {
  const { user, isAuthReady } = useContext(AuthContext);
  const location = useLocation();

  if (!isAuthReady) return null;
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;

  const allowed = user.role === "admin" || user.investmentAccess === true;
  if (!allowed) return <Navigate to="/" replace />;
  return children;
}
